import React from 'react'
import { render, screen } from '@testing-library/react'
import { ImageProps } from '@toasttab/shared/src/interfaces/Interface.d'
import TestimonialCard from '../TestimonialCard'

const baseProps = {
  bio: '',
  ctaImage: [] as ImageProps[],
  ctaLabel: '',
  dataTestId: 'TestimonialCard-1',
  eyebrow: '',
  headline: '',
  icon: [] as ImageProps[],
  image: [] as ImageProps[],
  restaurantName: '',
  sectionDescription: '',
  sectionHeading: '',
  singleSlide: false,
  slideIsActive: false,
  toggleSwitch: false,
  toggleSwitch2: false,
  videoButtonClasses: '',
  vidyardId: '',
  vidyardInteraction: ''
}

describe('Testimonial Card Tests', () => {
  it('renders without crashing', () => {
    render(<TestimonialCard {...baseProps} />)
    expect(screen.getByTestId('TestimonialCard-1')).toBeInTheDocument()
  })

  it('renders eyebrow text when provided', () => {
    const props = { ...baseProps, eyebrow: 'Test Eyebrow' }
    render(<TestimonialCard {...props} />)
    expect(screen.getByText('Test Eyebrow')).toBeInTheDocument()
  })

  it('renders icon when provided', () => {
    const props = {
      ...baseProps,
      icon: [{ url: 'icon.png', imageAlt: 'icon' }]
    }
    render(<TestimonialCard {...props} />)
    expect(screen.getByAltText('icon')).toBeInTheDocument()
  })

  it('renders headline when provided', () => {
    const props = { ...baseProps, headline: 'Test Headline' }
    render(<TestimonialCard {...props} />)
    expect(screen.getByText('Test Headline')).toBeInTheDocument()
  })

  it('renders section heading when raw is not provided', () => {
    const props = { ...baseProps, sectionHeading: 'Test Section Heading' }
    render(<TestimonialCard {...props} />)
    expect(screen.getByText('Test Section Heading')).toBeInTheDocument()
  })

  it('renders section heading when raw is provided', () => {
    const props = {
      ...baseProps,
      sectionHeading: {
        raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Test Raw Section Heading ","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
      }
    }
    render(<TestimonialCard {...props} />)
    expect(screen.getByText('Test Raw Section Heading')).toBeInTheDocument()
  })

  it('renders section description when provided', () => {
    const props = {
      ...baseProps,
      sectionDescription: 'Test Section Description'
    }
    render(<TestimonialCard {...props} />)
    expect(screen.getByText('Test Section Description')).toBeInTheDocument()
  })

  it('applies correct classes to section description based on isInlineQuote', () => {
    const props = {
      ...baseProps,
      sectionDescription: 'Test Section Description',
      isInlineQuote: true
    }
    render(<TestimonialCard {...props} />)
    expect(screen.getByText('Test Section Description')).toHaveClass(
      'text-secondary font-normal content-start text-center md:content-center mb-6 w-full'
    )
  })

  it('renders author container with correct classes based on isInlineQuote', () => {
    render(<TestimonialCard {...baseProps} />)
    const authorContainer = screen.getByTestId('TestimonialCard-author')
    expect(authorContainer).toHaveClass('items-center justify-center')
  })

  it('renders author container with different classes when image is provided', () => {
    render(
      <TestimonialCard
        {...baseProps}
        image={[{ classes: '', url: 'cta-image.jpg', title: 'cta image' }]}
        vidyardId='9c3678c4-7ce3-4e2c-98e5-479290d6a5e8'
      />
    )
    const authorContainer = screen.getByTestId('TestimonialCard-author')
    expect(authorContainer).toHaveClass('md:items-start')
  })

  it('renders correct elements when links are provided', () => {
    render(
      <TestimonialCard
        {...baseProps}
        links={[{ ctaLabel: 'Link 1', ctaLink: 'http://example.com' }]}
      />
    )
    expect(screen.getByText('Link 1')).toBeInTheDocument()
  })

  it('renders correct elements when ctaLabel and ctaImage are provided', () => {
    render(
      <TestimonialCard
        {...baseProps}
        ctaLabel={'Call to Action'}
        ctaImage={[{ url: 'cta-image.jpg', title: 'cta image' }]}
      />
    )
    expect(screen.getByText('Call to Action')).toBeTruthy()
    expect(screen.getByAltText('cta image')).toBeTruthy()
  })
})
